import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PayTillNowParkingSessionInfoDTO } from 'src/app/base/models/models.swagger.generated';
import { PriceUtils } from 'src/app/base/utils/price-utils';

@Component({
  selector: 'app-pay-till-now-session-active',
  imports: [TranslateModule],
  templateUrl: './pay-till-now-session-active.component.html',
  styleUrl: './pay-till-now-session-active.component.scss',
})
export class PayTillNowSessionActiveComponent implements OnInit {
  @Input() public sessionInfo: PayTillNowParkingSessionInfoDTO | null = null;
  @Output() public payNow: EventEmitter<void> = new EventEmitter<void>();

  public showReadyToLeaveMessage = false;
  public readyToLeaveTimestamp = '';

  public get sessionPriceWithCurrency(): string {
    if (this.sessionInfo) {
      return PriceUtils.getPriceWithCurrency(this.sessionInfo.totalWithVat, this.sessionInfo.currency);
    }
    return '';
  }

  constructor() { }

  ngOnInit() {
    this.showReadyToLeaveMessage = true;
    this.readyToLeaveTimestamp = this.sessionInfo?.timeStamp?.toFormat('HH:mm') ?? '';
  }

}
